// FAQ Action Types
export const GET_FAQS_START = 'GET_FAQS_START';
export const GET_FAQS_SUCCESS = 'GET_FAQS_SUCCESS';
export const GET_FAQS_ERROR = 'GET_FAQS_ERROR';

export const GET_FAQ_BY_ID_START = 'GET_FAQ_BY_ID_START';
export const GET_FAQ_BY_ID_SUCCESS = 'GET_FAQ_BY_ID_SUCCESS';
export const GET_FAQ_BY_ID_ERROR = 'GET_FAQ_BY_ID_ERROR';

export const CREATE_FAQ_START = 'CREATE_FAQ_START';
export const CREATE_FAQ_SUCCESS = 'CREATE_FAQ_SUCCESS';
export const CREATE_FAQ_ERROR = 'CREATE_FAQ_ERROR';

export const EDIT_FAQ_START = 'EDIT_FAQ_START';
export const EDIT_FAQ_SUCCESS = 'EDIT_FAQ_SUCCESS';
export const EDIT_FAQ_ERROR = 'EDIT_FAQ_ERROR';

export const DELETE_FAQ_START = 'DELETE_FAQ_START';
export const DELETE_FAQ_SUCCESS = 'DELETE_FAQ_SUCCESS';
export const DELETE_FAQ_ERROR = 'DELETE_FAQ_ERROR';